import { APIClient } from "./axiosClient";

export class ProgramApi {
    static fetchProgram(payload) {
        return APIClient('/program/getProgramsFromDB', payload, { requestType: 'post' });
    }

    static fetchOfferProgram(payload) {
        return APIClient('/program/getOfferProgramsFromDB', payload, { requestType: 'post' });
    }

    static getProgramsFromDB(payload = {
        pageNumber: 0,
        pageSize: 100,
        sortOrder: "desc",
        sortBy: "createdDate",
        programCode: null,
        programName: null,
        programType: "EARN"
      }) {
        return APIClient("/program/getProgramsFromDB", payload, { requestType: 'post' });
      } 

    static getActivityLogs(payload) {
        return APIClient(
            '/activity/getActivityLogs',
            payload,
            { requestType: 'post' }
        );
    }

    static verifyProgramDetails(payload: { programCode: string; domain: string }) {
        return APIClient(
            '/program/checkExistenceOfProgramDetails',
            payload,
            { requestType: 'post' }
        );
    }

    static getProgramDataUsingMerchantId(merchantId: string | number) {
        return APIClient(
            `/program/getProgramDataUsingMerchantId?merchantId=${merchantId}`
        );
    }

    static getProgramUsingId(programId: string | number) {
        return APIClient(
            `/program/getProgramUsingId?programId=${programId}`
        );
    }

    static deleteProgram(programId: number | string) {
        return APIClient(
            `/program/deleteProgram?programId=${programId}`,
            {},
            { requestType: 'delete' }
        );
    }
}